export const MONTHS = [
  {
    label: 'January',
    value: 'january',
  },
  {
    label: 'February',
    value: 'february',
  },
  {
    label: 'March',
    value: 'march',
  },
  {
    label: 'April',
    value: 'april',
  },
  {
    label: 'May',
    value: 'may',
  },
  {
    label: 'June',
    value: 'june',
  },
  {
    label: 'July',
    value: 'july',
  },
  {
    label: 'August',
    value: 'august',
  },
  {
    label: 'September',
    value: 'september',
  },
  {
    label: 'October',
    value: 'october',
  },
  {
    label: 'November',
    value: 'november',
  },
  {
    label: 'December',
    value: 'december',
  },
];

export const YEARS = Array.from({ length: 60 }, (_, i) => {
  const year = new Date().getFullYear() - i;
  return { label: year.toString(), value: year.toString() };
}).reverse();

export const FUTURE_YEARS = Array.from({ length: 21 }, (_, i) => {
  const year = new Date().getFullYear() + i;
  return { label: year.toString(), value: year.toString() };
});

export const AGREE_OPTIONS = [
  {
    label: 'Yes',
    value: true,
  },
  {
    label: 'No',
    value: false,
  },
];

export const DEPENDENT_CHILDREN_OPTIONS = Array.from({ length: 6 }, (_, i) => {
  return { label: i.toString() === '0' ? 'None' : i.toString(), value: i };
});

export const PROPERTY_LOCATION_TYPE_OPTIONS = [
  {
    label: 'Australian',
    value: 'australian',
  },
  {
    label: 'Overseas',
    value: 'overseas',
  },
];

export const OPTIONAL_AGREE_OPTIONS = [
  {
    label: 'Yes',
    value: 'yes',
  },
  {
    label: 'No',
    value: 'no',
  },
  {
    label: 'Maybe',
    value: 'maybe',
  },
];

export const FREQUENCY_OPTIONS = [
  {
    label: 'Weekly',
    value: 'weekly',
  },
  {
    label: 'Fortnightly',
    value: 'fortnightly',
  },
  {
    label: 'Monthly',
    value: 'monthly',
  },
  {
    label: 'Annually',
    value: 'annually',
  },
];

export const COMMISSION_FREQUENCY_OPTIONS = [
  {
    label: 'Weekly',
    value: 'weekly',
  },
  {
    label: 'Fortnightly',
    value: 'fortnightly',
  },
  {
    label: 'Monthly',
    value: 'monthly',
  },
  {
    label: 'Quarterly',
    value: 'quarterly',
  },
  {
    label: 'Annually',
    value: 'annually',
  },
];

export const LENDER_OPTIONS = [
  {
    label: 'ANZ',
    value: 'anz',
  },
  {
    label: 'Bankwest',
    value: 'bankwest',
  },
  {
    label: 'BOQ',
    value: 'boq',
  },
  {
    label: 'Citibank',
    value: 'citibank',
  },
  {
    label: 'Commonwealth Bank',
    value: 'commonwealth_bank',
  },
  {
    label: 'Heritage',
    value: 'heritage',
  },
  {
    label: 'Macquire',
    value: 'macquire',
  },
  {
    label: 'NAB',
    value: 'nab',
  },
  {
    label: 'Qudos',
    value: 'qudos',
  },
  {
    label: 'St. George / BoM / BoSA',
    value: 'st_george_or_bom_bosa',
  },
  {
    label: 'Suncorp',
    value: 'suncorp',
  },
  {
    label: 'Westpac',
    value: 'westpac',
  },
  {
    label: 'Other - Australian Lender',
    value: 'otther_australian_lender',
  },
  {
    label: 'Other - Foreign Lender',
    value: 'other_foreign_lender',
  },
];

export const PROPERTY_LENDER_OPTIONS = [
  { label: 'AAA', value: 'aaa' },
  { label: 'ANZ', value: 'anz' },
  { label: 'ANZ Private', value: 'anz_private' },
  { label: 'Bank of Melbourne', value: 'bank_of_melbourne' },
  { label: 'Bank of Queensland', value: 'boq' },
  { label: 'Bankwest', value: 'bankwest' },
  { label: 'Bankwest Private', value: 'bankwest_private' },
  { label: 'BC Invest', value: 'bc_invest' },
  { label: 'Brighten', value: 'brighten' },
  { label: 'CBA', value: 'commonwealth_bank' },
  { label: 'Citibank-AU', value: 'citibank' },
  { label: 'Great Southern Bank', value: 'great_southern_bank' },
  { label: 'Heritage', value: 'heritage' },
  { label: 'HSBC-AU', value: 'hsbc_au' },
  { label: 'HSBC-SG', value: 'hsbc_sg' },
  { label: 'ING', value: 'ing' },
  { label: 'LA Trobe', value: 'la_trobe' },
  { label: 'MA Money', value: 'ma_money' },
  { label: 'Macquarie', value: 'macquarie' },
  { label: 'MEZY', value: 'mezy' },
  { label: 'NAB', value: 'nab' },
  { label: 'NAB Private', value: 'nab_private' },
  { label: 'OCBC-HK', value: 'ocbc_hk' },
  { label: 'Other', value: 'other' },
  { label: 'Qudos', value: 'qudos' },
  { label: 'St. George', value: 'st_george' },
  { label: 'Suncorp', value: 'suncorp' },
  { label: 'Ubank', value: 'ubank' },
  { label: 'Virgin Money', value: 'virgin_money' },
  { label: 'Westpac', value: 'westpac' },
];

export const RATE_TYPE_OPTIONS = [
  {
    label: 'Variable rate loan',
    value: 'variable',
  },
  {
    label: 'Fixed rate loan',
    value: 'fixed',
  },
];

export const PROPERTY_OWNER_TYPE_OPTIONS = [
  {
    label: 'I own this',
    value: 'own',
  },
  {
    label: 'Co-applicant owns this',
    value: 'coapplicant_own',
  },
  {
    label: 'Jointly owned with co-applicant',
    value: 'jointly_own',
  },
  {
    label: 'Owned with other(s)',
    value: 'own_with_other',
  },
  {
    label: 'Trust / Company',
    value: 'trust_or_company',
  },
];

export const TAX_PROPERTY_OWNER_TYPE_OPTIONS = [
  {
    label: 'I own this',
    value: 'own',
  },
  {
    label: 'Jointly owned with my partner',
    value: 'jointly_owned_with_my_partner',
  },
  {
    label: 'Jointly owned with someone else',
    value: 'jointly_owned_with_someone_else',
  },
  {
    label: 'Trust / Company',
    value: 'trust_or_company',
  },
];

export const PROPERTY_USE_TYPE_OPTIONS = [
  {
    label: 'Primary residence',
    value: 'primary_residence',
  },
  {
    label: 'Investment (rented)',
    value: 'rented',
  },
  {
    label: 'Investment (airbnb/short-term lease)',
    value: 'short_term_lease',
  },
  {
    label: 'Investment (untenanted)',
    value: 'untenanted',
  },
  {
    label: 'Commercial property',
    value: 'commercial',
  },
];

export const TAX_PROPERTY_USE_TYPE_OPTIONS = [
  {
    label: 'Main residence (rented out)',
    value: 'main_residence_rented_out',
  },
  {
    label: 'Main residence (privately used)',
    value: 'main_residence_privately_used',
  },
  {
    label: 'Investment (rented)',
    value: 'rented',
  },
  {
    label: 'Investment (airbnb/short-term lease)',
    value: 'short_term_lease',
  },
  {
    label: 'Investment (untenanted)',
    value: 'untenanted',
  },
  {
    label: 'Commercial property',
    value: 'commercial',
  },
];

export const OVERSEAS_PROPERTY_PURPOSE_OPTIONS = [
  {
    label: 'Owner Occupier Home',
    value: 'owner_occupier_home',
  },
  {
    label: 'Investment Property',
    value: 'investment_property',
  },
];

export const STATES_OPTIONS = [
  {
    label: 'New South Wales (NSW)',
    value: 'nsw',
  },
  {
    label: 'Victoria (VIC) ',
    value: 'vic',
  },
  {
    label: 'Queensland (QLD)',
    value: 'qld',
  },
  {
    label: 'Western Australia (WA)',
    value: 'wa',
  },
  {
    label: 'Southern Australia (SA)',
    value: 'sa',
  },
  {
    label: 'Tasmania (TAS)',
    value: 'tas',
  },
  {
    label: 'Northern Territory (NT)',
    value: 'nt',
  },
  {
    label: 'Australian Capital Territory (ACT)',
    value: 'act',
  },
];

export const EMPLOYMENT_OPTIONS = [
  {
    label: 'Employee',
    value: 'employee',
  },
  {
    label: 'Self-Employed (Sole trader / Contractor)',
    value: 'self_employed_trader_or_contractor',
  },
  {
    label: 'Self- Employed (Company)',
    value: 'self_employed_company',
  },
  {
    label: 'Unemployed / Home Duties',
    value: 'unemployed                ',
  },
];

export const TAX_EMPLOYMENT_OPTIONS = [
  ...EMPLOYMENT_OPTIONS,
  {
    label: 'No Foreign Income Earned',
    value: 'no_foreign_income_earned',
  },
];

export const LOAN_TYPE_OPTIONS = [
  {
    label: 'Personal Loan',
    value: 'personal_loan',
  },
  {
    label: 'Car Loan',
    value: 'car_loan',
  },
  {
    label: 'Tax Loan',
    value: 'tax_loan',
  },
  {
    label: 'Margin Loan',
    value: 'margin_loan',
  },
  {
    label: 'Student Loan',
    value: 'student_loan',
  },
];

export const RELATIONSHIP_OPTIONS = [
  {
    label: 'My Spouse',
    value: 'my_spouse',
  },
  {
    label: 'My Partner (Unmarried)',
    value: 'my_partner',
  },
  {
    label: 'My Mother/Father',
    value: 'my_mother_or_father',
  },
  {
    label: 'My Brother/Sister/Relative',
    value: 'my_brother_sister_relative',
  },
  {
    label: 'My friend',
    value: 'friend',
  },
  {
    label: 'My Child',
    value: 'child ',
  },
];

export const CITIZENSHIP_OPTIONS = [
  {
    value: 'australian_citizen',
    label: 'Australian Citizen',
  },
  {
    value: 'australian_pr_visa',
    label: 'Australian PR Visa',
  },
  {
    value: 'australian_tr_visa',
    label: 'Australian TR Visa',
  },
  {
    value: 'newzeland_citizen',
    label: 'New Zealand Citizen',
  },
  {
    value: 'foreign_national',
    label: 'Foreign National',
  },
];

export const MARITIAL_STATUS_OPTIONS = [
  {
    label: 'Single',
    value: 'single',
  },
  {
    label: 'Married',
    value: 'married',
  },
  {
    label: 'De-facto',
    value: 'defacto',
  },
  {
    label: 'Divorced',
    value: 'divorced',
  },
  {
    label: 'Widowed',
    value: 'widowed',
  },
];

export const RESIDENTIAL_STATUS_OPTIONS = [
  {
    label: 'I’m renting',
    value: 'renting',
  },
  {
    label: 'I live in my own place',
    value: 'live_own_place',
  },
  {
    label: 'I’m rent free/ boarding (parent)',
    value: 'rent_free_or_boarding_parent',
  },
  {
    label: 'I live rent free/ boarding (spouse)',
    value: 'rent_free_or_boarding_spouse',
  },
  {
    label: 'I live rent free/ boarding (friend)',
    value: 'rent_free_or_boarding_friend',
  },

  {
    label: 'live rent free/ boarding (employer provides)',
    value: 'rent_free_or_boarding_employer',
  },
  {
    label: 'Other (Provide Specification)',
    value: 'other',
  },
];

export const WHERE_DID_YOU_HEAR_ABOUT_US_OPTIONS = [
  {
    label: 'Google',
    value: 'google',
  },
  {
    label: 'Google Ads',
    value: 'google_ads',
  },
  {
    label: 'Blog Articles',
    value: 'blog_articles',
  },
  {
    label: 'Word of Mouth',
    value: 'word_of_mouth',
  },
  {
    label: 'Facebook',
    value: 'facebook',
  },
  {
    label: 'Australian Associations',
    value: 'australian_associations',
  },
  {
    label: 'Professional Referral (Agent/Fin. Planners)',
    value: 'professional_referral_agent_fin_planners',
  },
  {
    label: 'Social Media',
    value: 'social_media',
  },
  {
    label: 'Webinars',
    value: 'webinars',
  },
  {
    label: 'Existing Client',
    value: 'existing_client',
  },
  {
    label: 'LinkedIn',
    value: 'linkedin',
  },
  {
    label: 'Other',
    value: 'other',
  },
];

export const OVERSEAS_PROPERTY_USE_OPTIONS = [
  {
    label: 'Owner Occupier Home',
    value: 'owner_occupier_home',
  },
  {
    label: 'Investment Property',
    value: 'investment_property',
  },
];

export const PRIVATE_SCHOOL_OPTIONS = [
  {
    label: 'Yes',
    value: 'yes',
  },
  {
    label: 'No',
    value: 'no',
  },
  {
    label: 'Yes, but covered by employer',
    value: 'yes_covered_by_employer',
  },
];

export const TAX_RESIDENCY_OPTIONS = [
  { label: 'Non-tax Resident', value: 'non_tax_resident' },
  { label: 'Australian Tax Resident', value: 'australian_tax_resident' },
  {
    label: 'Part Year Tax Resident (Leaving Aus)',
    value: 'part_year_tax_resident_leaving_aus',
  },
  {
    label: 'Part Year Tax Non-Resident (Returning Aus)',
    value: 'part_year_tax_non_resident_returning_aus',
  },
  { label: 'Unsure', value: 'unsure' },
];
